module.exports = __webpack_public_path__ + "img/zl3.b800d7c7.png";